import colors from '../../colors';

const globalHeader = {
  colors: {
    backgroundColor: colors.primary.studioBkgd,
    brand: colors.primary.white,
    link: colors.primary.white,
    mobileLink: colors.primary.darkGrey,
    mobileLinkBackground: colors.primary.white,
    navbarToggler: colors.primary.white,
    border: colors.primary.dkBlue1,
    braze: colors.notifications.purple[700],
    subHeader: colors.accent.lightPurple,
  },
};

export default globalHeader;
